jQuery(document).ready(function () {
  function HideMessage() {
    jQuery('.c-notice-banner').fadeOut(400);
    var currentTime = Math.floor(Date.now() / 1000);
    var noticeMessage = {
      message: jQuery('.c-notice-banner').html(),
      time: currentTime,
      clicked: true
    };
    localStorage.setItem('noticeMessageJSON', JSON.stringify(noticeMessage));
  }

  function displayNoticeMessage() {
    console.log('Display message...');
    jQuery('.c-notice-banner').fadeIn(400);
    jQuery('.c-notice-banner__close').click(function () {
      HideMessage();
    });
  }

  function checkNoticeMessage() {
    if (localStorage.getItem('noticeMessageJSON')) {
      console.log('Checking message...');

      try {
        var noticeMessageTimeout = 86400; //24 hours

        var noticeMessage = jQuery('.c-notice-banner').html();
        var currentTimestamp = Math.floor(Date.now() / 1000);
        var noticeMessageData = JSON.parse(localStorage.getItem('noticeMessageJSON'));

        if (noticeMessageData) {
          if (noticeMessage == noticeMessageData.message && currentTimestamp - noticeMessageData.time < noticeMessageTimeout) {
            return;
          }
        }
      } catch (e) {
        console.error(e);
      }
    }

    displayNoticeMessage();
  }

  checkNoticeMessage();
});